import styles from "./Labels.module.css";

const Copyright = () => {
  const currentYear = new Date().getFullYear();
  return <p className={styles.copyright}>© {currentYear} Q Comm IP, LLC</p>;
};

export default Copyright;
